import(/* webpackMode: "eager", webpackExports: ["AppButton"] */ "/vercel/path0/app/blog/[post]/AppButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CTASection"] */ "/vercel/path0/app/blog/[post]/CTASection.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/basic/Img/Img.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/LoadingSkeleton/LoadingSkeleton.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/Post/Post.module.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/Slider/Slider.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/pagestyles/article.module.scss");
